import ProjectCustomersTrash from "./components/ProjectCustomersTrash";

export default ProjectCustomersTrash;
